import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { IParamsPlant } from '@shared/interfaces/parameter-plant.interface';

@Injectable({
  providedIn: 'root',
})
export class ArkikSelectorService {
  private baseUrl: string;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.APIM + environment.newOrderAPI;
  }

  getParameterByDetails(ParameterCode: string, ScopeId: number, ParameterScopeTypeId: number) {
    let options: object;
    options = {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set('Ocp-Apim-Subscription-Key', environment.apimSubscriptionKey),
      responseType: 'text',
    };

    return this.http.put(
      `${this.baseUrl}Parameter/GetParameterData/`,
      {
        ParameterCode: ParameterCode,
        ScopeId: ScopeId,
        ParameterScopeTypeId: ParameterScopeTypeId,
      },
      options,
    );
  }

  async getParameter(paramName: string): Promise<IParamsPlant> {
    let paramInfo: IParamsPlant;
    const paramValue = sessionStorage.getItem(paramName);
    if (paramValue) {
      paramInfo = JSON.parse(paramValue) as IParamsPlant;
    } else {
      const value = (await this.getParameterByDetails('EDIT_MASTER_DATA', null, 5).toPromise()) as string;
      paramInfo = {
        parameterCode: paramName,
        parameterDesc: paramName,
        parameterValue: value ? Number(value) : null,
      };
      sessionStorage.setItem(paramName, JSON.stringify(paramInfo));
    }
    return paramInfo;
  }
}
